import React from 'react'
import styles from './sidebar.module.scss'
import { BoardIcon } from '../../../../assets/icons/board-icon'
function BoardList({ data = [], activeBoard, setActiveBoard }) {
    return (
        <div className={styles.board_list_container}>
            <div className={styles.all_boards_txt}>ALL Boards ({data.length})</div>
            <div>
                {data?.map((sideBarItem, index) => <div key={index} className={`${activeBoard == index ? styles.active : ""} ${styles.board_list_item}`}
                    onClick={() => setActiveBoard(index)}>
                    <BoardIcon color={activeBoard == index ? "#fff" : "#828FA3"} />
                    <span>{sideBarItem}</span>
                </div>)}
                <div className={styles.create_borad_txt}>
                    <BoardIcon color={"#828FA3"} />
                    <span>+ Create New Board</span>
                </div>

            </div>
        </div>
    )
}

export default BoardList